import React from 'react';
import s from './Purchases.module.scss';

const Confirmation = () => {
  return (
    <div className={s.upload_image}>
      <div className={s.upload_image_title}>Confirm return</div>
      <div className={s.upload_image_description}>
        <div className={s.upload_image_description_title}>
          Are you sure you want to return this item?
        </div>
        <div className={s.upload_image_description_text}>
          Please review your selection before proceeding. By confirming, you agree to our return
          policy and terms of service. You will receive a confirmation email once the return process
          is initiated.
        </div>
      </div>
    </div>
  );
};

export default Confirmation;
